/**
 * months: [ { products: [ {}, {}, {} ] }, { products: [ {}, {}, {} ] }, ... ]
 * return products: [ {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, ... ]
 */
const getAllQueueProductsArray = <T extends { id: number }>(months: { products: T[] }[] = [], withoutEmpty?: Boolean): T[] => {
  const allProducts: T[] = months.reduce((arr: T[], { products }) => [ ...arr, ...products ], [])

  if (withoutEmpty) {
    return allProducts.filter((product) => product && product.id)
  }

  return allProducts
}


export default getAllQueueProductsArray
